import React from "react";
import { ItemLogo } from "../SelectionGrid";
import { Grid, Heading, Line, More, Thumb, Wrap } from "./ThumbnailOverflowGrid.styles";
import type { ThumbnailOverflowGridProps } from "./ThumbnailOverflowGrid.types";

/** A heading over the first few thumbnails (logo or initials, two lines) and a "+N" cell for the rest. */
export const ThumbnailOverflowGrid: React.FC<ThumbnailOverflowGridProps> = ({
  items,
  heading,
  total,
  visibleCount = 3,
  className,
}) => {
  const rest = Math.max((total ?? items.length) - visibleCount, 0);
  return (
    <Wrap className={className} data-testid="thumbnail-overflow-grid">
      <Heading>{heading}</Heading>
      <Grid aria-label={heading}>
        {items.slice(0, visibleCount).map((item) => (
          <Thumb key={item.id} $active={!!item.active} aria-label={item.label} data-active={item.active ? "true" : undefined}>
            <ItemLogo label={item.label} logoSrc={item.logoSrc} initials={item.initials} accent={item.accent} size={1} />
            <Line $short />
            <Line />
          </Thumb>
        ))}
        {rest > 0 && <More data-testid="thumbnail-more">+{rest}</More>}
      </Grid>
    </Wrap>
  );
};

export default ThumbnailOverflowGrid;
